'use client'

/**
 * Client-only provider (cannot be a React Server Component):
 * - Uses createContext + useReducer; RSC cannot own client state or context.
 * - Children (e.g. PaginatedArticlesList) dispatch updates and POST to /api/contentful/* after hydration.
 *
 * SSR path: parent Server Components pass serialized `defaultState` built with
 * buildArticlesFilterDefaultState() (see ArticlesFilterProviderServer) so the first client paint
 * matches the HTML from the server fetch.
 */
import { createContext, useReducer } from 'react'

const ArticlesFilterContext = createContext()

const ArticlesFilterReducer = (state, action) => {
  switch (action.type) {
    case 'INITIALIZE':
      return { ...state, ...action.payload }
    case 'SET_PAGE':
      return { ...state, page: action.payload }
    case 'SET_TITLE':
      return { ...state, title: action.payload }
    case 'SET_ARTICLES':
      return { ...state, articlesObject: action.payload }
    case 'SET_KEYWORDS':
      return { ...state, keywordsFilter: action.payload }
    case 'SET_FILTER_BY':
      return { ...state, filterBy: action.payload }
    case 'SET_ORDER_BY':
      return { ...state, orderBy: action.payload }
    default:
      return state
  }
}

const ArticlesFilterProvider = ({ children, defaultState = {} }) => {
  const [state, dispatch] = useReducer(ArticlesFilterReducer, defaultState)
  return (
    <ArticlesFilterContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </ArticlesFilterContext.Provider>
  )
}

export { ArticlesFilterProvider, ArticlesFilterContext }
